/**
 * SocialInstagramIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const SocialInstagramIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fillRule="evenodd"
      d="M8.925 8.925a4.35 4.35 0 1 1 6.151 6.15 4.35 4.35 0 0 1-6.151-6.15m5.09 1.06a2.85 2.85 0 1 0-4.03 4.03 2.85 2.85 0 0 0 4.03-4.03"
      clipRule="evenodd"
    />
    <path d="M16.998 6a1 1 0 1 1 .006 1.998A1 1 0 0 1 16.998 6" />
    <path
      fillRule="evenodd"
      d="M16.774 2.257a5.246 5.246 0 0 1 4.976 5.24v9.008a5.245 5.245 0 0 1-5.246 5.245H7.496a5.246 5.246 0 0 1-5.246-5.246V7.496A5.246 5.246 0 0 1 7.496 2.25h9.009zM7.496 3.75A3.746 3.746 0 0 0 3.75 7.496v9.008a3.746 3.746 0 0 0 3.746 3.746h9.008a3.745 3.745 0 0 0 3.746-3.745V7.496a3.745 3.745 0 0 0-3.553-3.741l-.192-.005z"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const SocialInstagramIcon = makeIcon('SocialInstagramIcon', SocialInstagramIconSvg)
